var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33334 3.66668C4.15652 3.66668 3.98696 3.73691 3.86193 3.86194C3.73691 3.98696 3.66667 4.15653 3.66667 4.33334V11.6667C3.66667 11.8435 3.73691 12.0131 3.86193 12.1381C3.98696 12.2631 4.15653 12.3333 4.33334 12.3333H11.6667C11.8435 12.3333 12.013 12.2631 12.1381 12.1381C12.2631 12.0131 12.3333 11.8435 12.3333 11.6667V7.00001H13.6667V11.6667C13.6667 12.1971 13.456 12.7058 13.0809 13.0809C12.7058 13.456 12.1971 13.6667 11.6667 13.6667H4.33334C3.8029 13.6667 3.29419 13.456 2.91912 13.0809C2.54405 12.7058 2.33334 12.1971 2.33334 11.6667V4.33334C2.33334 3.80291 2.54405 3.2942 2.91912 2.91913C3.2942 2.54406 3.8029 2.33334 4.33334 2.33334H9V3.66668H4.33334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOut);
export default __webpack_public_path__ + "static/media/link-out.dce897c5e60cec3f27781fd2db021387.svg";
export { ForwardRef as ReactComponent };